import React from "react";
import { FC } from "react";
import { Col, Row, Typography } from "antd";
import { IReferralLetter } from "../../../../interfaces/IReferral";
import dayjs from "dayjs";

type EchsDetailProps = {
  data: IReferralLetter;
  type?: string;
};

const EchsDetailCNM: FC<EchsDetailProps> = ({ data, type }) => {
  const { Text } = Typography;
  return (
    <div className="cghsDetail-main">
      <Row
        gutter={[16, 16]}
        style={{ width: "100%", margin: "0px" }}
        className="first-row-cghsdetail"
      >
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">REFERRAL NO</Text>{" "}
            {data.referralNo || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">DATE OF ISSUE</Text>
            {type === "credit-modal"
              ? dayjs(data?.referralExpiryFrom, "DD-MM-YYYY").format(
                  "DD-MMM-YYYY"
                )
              : data?.referralExpiryFrom}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">VALID UPTO</Text>
            {type === "credit-modal"
              ? dayjs(data?.referralExpiryTo, "DD-MM-YYYY").format(
                  "DD-MMM-YYYY"
                )
              : data?.referralExpiryTo}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">NO OF VISIT LEFT</Text>{" "}
            {data?.noOfVisits || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">REFERRING DOCTOR</Text>{" "}
            {data?.referringDoctor?.toUpperCase() || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">REFERRAL FOR</Text>{" "}
            {data?.referralFor?.toUpperCase() || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">PATIENT TYPE</Text>{" "}
            {data?.referralType?.toUpperCase() || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">CARD CATEGORY</Text>{" "}
            {data?.cardCategory?.toUpperCase() || "-"}
          </div>
        </Col>
      </Row>

      <Row
        gutter={[16, 16]}
        style={{ width: "100%", margin: "0px" }}
        className="second-row-cghsdetail"
      >
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">CARD NO</Text>{" "}
            {data?.cardNumber || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">SERVICE NO</Text>{" "}
            {data?.serviceNumber || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">CLINICAL NOTES</Text>{" "}
            {data?.clinicalNotes || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">ADMISSION</Text>{" "}
            {data?.admission || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">INVESTIGATION</Text>{" "}
            {data?.investigation || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">CONSULTATION FOR</Text>{" "}
            {data?.consultationFor || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">IS ARI & SC?</Text>{" "}
            {data?.investigation || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">IS IP ALLOWED?</Text>{" "}
            {data?.consultationFor || "-"}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EchsDetailCNM;
